export const UNSET_USER_INFO = 'UNSET_USER_INFO'

export const SET_USER_INFO = 'SET_USER_INFO'

export const TOGGLE_DRAWER = 'TOGGLE_DRAWER'

export const TOGGLE_LOADING = 'TOGGLE_LOADING'

export const TOGGLE_SNACKBAR = 'TOGGLE_SNACKBAR'

export const RESET_FORM = "RESET_FORM"

export const TOGGLE_MODAL_MAINCLIENT = 'TOGGLE_MODAL_MAINCLIENT'
export const TOGGLE_MODAL_SUBCLIENT = 'TOGGLE_MODAL_SUBCLIENT'
export const TOGGLE_MODAL_USERUNIT = 'TOGGLE_MODAL_USERUNIT'
export const TOGGLE_MODAL_BASEUNIT = 'TOGGLE_MODAL_BASEUNIT'
export const TOGGLE_MODAL_ADDITEM = 'TOGGLE_MODAL_ADDITEM'
export const TOGGLE_MODAL_EXCHANGERATES = 'TOGGLE_MODAL_EXCHANGERATES'

export const TOAST = 'TOAST'

export const InterConnectionRevenueForm_TEXT_CHANGE = 'InterConnectionRevenueForm_TEXT_CHANGE'
export const InterConnectionRevenueForm_FILE_CHANGE = 'InterConnectionRevenueForm_FILE_CHANGE'

export const InterConnectionRevenueForm_COMPANIES_TEXT_CHANGE = 'InterConnectionRevenueForm_COMPANIES_TEXT_CHANGE'
export const InterConnectionRevenueForm_COMPANIES_FILE_CHANGE = 'InterConnectionRevenueForm_COMPANIES_FILE_CHANGE'

export const InterConnectionChargeForm_TEXT_CHANGE = 'InterConnectionChargeForm_TEXT_CHANGE'
export const InterConnectionChargeForm_COMPANIES_TEXT_CHANGE = 'InterConnectionChargeForm_COMPANIES_TEXT_CHANGE'

export const PrepaymentRevenueForm_TEXT_CHANGE = 'PrepaymentRevenueForm_TEXT_CHANGE'

export const PaymentTermForm_TEXT_CHANGE = 'PaymentTermForm_TEXT_CHANGE'

export const ComercialRevenueForm_TEXT_CHANGE = 'ComercialRevenueForm_TEXT_CHANGE'